import { Organization } from '@raystack/frontier';

import { LAST_ORGANIZATION_KEY_NAME } from './constants/APP';
import { AUTH_ROUTES, ROUTES } from './constants/Routes';

export function getOrgSlugToNavigate(orgList: Organization[] = []) {
  const lastOrgSlug = localStorage.getItem(LAST_ORGANIZATION_KEY_NAME);
  const org = orgList.find(org => org.name === lastOrgSlug) || orgList[0];
  return org?.name;
}

export function isAuthRoute(currentPath: string): boolean {
  if (currentPath === ROUTES.ROOT) {
    return true;
  }
  return AUTH_ROUTES.some(authRoute => currentPath.startsWith(authRoute));
}
